(function ($) {
    'use strict';

    /**
     * Handle Login Form Submission
     */
    const handleLogin = () => {
        const loginForm = $('#seasonic-login-form');
        if (loginForm.length === 0) return;

        loginForm.on('submit', function (e) {
            e.preventDefault();

            const form = $(this);
            const submitBtn = form.find('button[type="submit"]');
            const messageContainer = form.find('.message-container');

            // Clear previous messages and errors
            messageContainer.removeClass('success error').html('').hide();
            form.find('input').removeClass('error');
            form.find('.field-error').html('').hide();

            // Disable button
            submitBtn.prop('disabled', true).addClass('loading');

            const formData = {
                action: 'seasonic_login',
                security: seasonic_auth_data.security_nonce,
                email: form.find('input[name="email"]').val(),
                password: form.find('input[name="password"]').val(),
                remember: form.find('input[name="remember"]').is(':checked')
            };

            $.post(seasonic_auth_data.ajax_url, formData, function (response) {
                if (response.success) {
                    messageContainer.removeClass('error').addClass('success')
                        .html(`<div class="msg-box success-box">${response.data.message}</div>`).fadeIn();

                    // Redirect after a short delay
                    setTimeout(() => {
                        window.location.href = response.data.redirect;
                    }, 1500);
                } else {
                    const error = response.data;

                    // Show error in the main container at the bottom
                    messageContainer.removeClass('success').addClass('error')
                        .html(`
                            <div class="msg-box error-box">
                                <span class="error-icon"></span>
                                <span class="error-text">${error.message}</span>
                            </div>
                        `).fadeIn();

                    submitBtn.prop('disabled', false).removeClass('loading');
                }
            }).fail(function () {
                messageContainer.removeClass('success').addClass('error')
                    .html(`<div class="msg-box error-box">An error occurred. Please try again.</div>`).fadeIn();
                submitBtn.prop('disabled', false).removeClass('loading');
            });
        });
    };

    /**
     * Handle Logout
     */
    const handleLogout = () => {
        $(document).on('click', '.seasonic-logout-link', function (e) {
            e.preventDefault();

            if (!confirm('Are you sure you want to log out?')) return;

            $.post(seasonic_auth_data.ajax_url, {
                action: 'seasonic_logout',
                security: seasonic_auth_data.security_nonce
            }, function (response) {
                if (response.success) {
                    window.location.href = response.data.redirect;
                }
            });
        });
    };

    /**
     * Handle Password Toggle
     */
    const handlePasswordToggle = () => {
        $(document).on('click', '.password-toggle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('1231')
            const toggle = $(this);
            const input = toggle.closest('.password-input-wrapper').find('input');
            
            if (input.attr('type') === 'password') {
                input.attr('type', 'text');
                toggle.addClass('visible');
            } else {
                input.attr('type', 'password');
                toggle.removeClass('visible');
            }
        });
    };

    /**
     * Handle AJAX Registration
     */
    const handleRegister = () => {
        const form = $("#seasonic-register-form");
        if (form.length === 0) return;

        form.on("submit", function (e) {
            e.preventDefault();

            const btn = $(this).find('button[type="submit"]');
            const msgContainer = $(this).find(".message-container");
            const formData = $(this).serialize();

            // Clear previous errors
            $(this).find('input').removeClass('error');
            msgContainer.hide().html('');

            btn.prop("disabled", true).addClass("loading");

            $.post(seasonic_auth_data.ajax_url, formData + "&action=seasonic_register&security=" + seasonic_auth_data.security_nonce, function (response) {
                btn.prop("disabled", false).removeClass("loading");

                if (response.success) {
                    $('#auth-header-register').find('.auth-subtitle').hide();
                    form.hide();
                    
                    const userEmail = response.data.email || 'your email';
                    $('#seasonic-register-form-wrap').html(`
                        <div class="registration-success-message text-center pt-3 pb-4">
                            <p class="mb-4" >We have sent a message to<br><strong>${userEmail}</strong></p>
                            
                            <p class="mb-2" >Click on the link in the email we sent to your email.</p>
                            <p class="mb-5" >If you don't see the email, please check your Spam folder.</p>
                            
                            <div class="form-register-link">
                                <span>Already have the account?</span>
                                <a href="${seasonic_auth_data.myaccount_url || '/my-account/'}" class="login-toggle btn btn-text btn-sm">LOGIN</a>
                            </div>
                        </div>
                    `).fadeIn();
                } else {
                    if (response.data.type) {
                        form.find('#reg_' + response.data.type).addClass('error');
                    }
                    msgContainer.html(`
                        <div class="msg-box error-box">
                            <span class="error-icon"></span>
                            <span class="error-text">${response.data.message}</span>
                        </div>
                    `).fadeIn();
                }
            }).fail(function () {
                msgContainer.html('<div class="msg-box error-box">An error occurred. Please try again.</div>').fadeIn();
                btn.prop("disabled", false).removeClass("loading");
            });
        });
    };

    /**
     * Handle AJAX Lost Password
     */
    const handleLostPassword = () => {
        $(document).on("submit", "#seasonic-lost-password-form", function (e) {

            e.preventDefault();

            const form = $(this);
            const btn = form.find('button[type="submit"]');
            const wrap = $("#seasonic-lost-password-form-wrap");
            const msgContainer = wrap.find(".message-container");
            const email = form.find('input[name="email"]').val();

            msgContainer.hide().html('');
            btn.prop("disabled", true).addClass("loading");

            $.post(seasonic_auth_data.ajax_url, {
                action: 'seasonic_lost_password',
                security: seasonic_auth_data.security_nonce,
                email: email
            }, function (response) {
                btn.prop("disabled", false).removeClass("loading");

                if (response.success) {
                    // form.hide();
                    msgContainer.html(`<div class="msg-box success-box">${response.data.message}</div>`).fadeIn();
                } else {
                    msgContainer.html(`
                        <div class="msg-box error-box">
                            <span class="error-icon"></span>
                            <span class="error-text">${response.data.message}</span>
                        </div>
                    `).fadeIn();
                }
            }).fail(function () {
                msgContainer.html(`
                    <div class="msg-box error-box">
                        <span class="error-icon"></span>
                        <span class="error-text">An error occurred. Please try again.</span>
                    </div>
                `).fadeIn();
                btn.prop("disabled", false).removeClass("loading");
            });
        });
    };

    /**
     * Handle Form Toggles (Lost Password)
     */
    const handleFormToggles = () => {
        // Toggle to Lost Password (since it's on the same page as Login)
        $(document).on('click', '.forgot-password', function (e) {
            if ($('#seasonic-lost-password-form-wrap').length > 0) {
                e.preventDefault();
                $('#seasonic-login-form-wrap, #auth-header-login, #seasonic-register-form-wrap, #auth-header-register').hide();
                $('#seasonic-lost-password-form-wrap, #auth-header-lost-password').fadeIn();
            }
        });

        // Toggle back to Login from Lost Password
        $(document).on('click', '.back-to-login', function (e) {
            if ($('#seasonic-lost-password-form-wrap').is(':visible')) {
                e.preventDefault();
                $('#seasonic-lost-password-form-wrap, #auth-header-lost-password').hide();
                $('#seasonic-login-form-wrap, #auth-header-login').fadeIn();
            }
        });
    };

    // Initialize
    $(document).ready(function () {
        console.log('Seasonic Auth Script: Active');
        handleLogin();
        handleRegister();
        handleLostPassword();
        handleLogout();
        handlePasswordToggle();
        handleFormToggles();
    });

})(jQuery);
